<div class="product-card" 
     *ngIf="product" 
     [class.cart-empty]="isCartEmpty" 
     [class.category-layout]="isCartEmpty && useCategoryLayoutWhenEmpty">

  <ng-container *ngIf="isCartEmpty && useCategoryLayoutWhenEmpty">
    <div class="category-item-wrapper" (click)="onAdd(product)">
      <div class="product-icon">
          <umkt-icon [icon]="getIcon()" [size]="useCategoryLayoutWhenEmpty ? 'lg' : 'md'"></umkt-icon>
      </div>
      <div class="product-name">{{ product.name | i18n }}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="!(isCartEmpty && useCategoryLayoutWhenEmpty)">
    <header class="product-header">
      <div class="product-icon">
          <umkt-icon [icon]="getIcon()"></umkt-icon>
      </div>
      <div class="product-info">
        <div class="product-title">
          <div class="product-name">{{ product.name}}</div>
          <a *ngIf="showProductTerm && product.termsUrl" class="terms-link" [href]="product.termsUrl" target="_blank" rel="noopener noreferrer" role="button"> 
            {{ 'components.cartProductItem.viewTerms' | i18n }}
          </a>
        </div>   
        <div class="button_cart-empty" *ngIf="isCartEmpty">
          <button type="button" class="pi-edit" (click)="onAdd(product)">
            {{ 'components.cartProductItem.addButton' | i18n }}
          </button>
        </div>
      </div>
    </header>

    <div class="product-details" *ngIf="!isCartEmpty">
      <p *ngIf="showDetailsLabel">{{ 'components.cartProductItem.detailsLabel' | i18n }}</p>
      <ul>
        <ng-container *ngFor="let plan of product.plans; trackBy: trackByPlanId">
          <li class="plan-item" [@fadeCollapse] *ngIf="!removedPlans.has(plan.id)">
            <span *ngIf="!isMind" class="plan-name">{{ plan.name }}</span>

            <div class="plan-actions">
              <div class="qty-counter">
                <button (click)="onDecrement(plan)" class="counter-btn">-</button>
                <span class="qty">{{ plan.quantity ?? 1 | number:'2.0' }}</span>
                <button (click)="onIncrement(plan)" [class.counter-disabled]="isPlusDisabled(plan)" [disabled]="isPlusDisabled(plan)" class="counter-btn">+</button>
              </div>

              <div class="plan-value">
                <span
                  class="plan-badge"
                  *ngIf="isMind && plan.hasPromotion"
                >{{ 'components.productCard.ofertaClaro' | i18n }}</span>
                <span class="plan-price">
                  {{ (getAdjustedPrice(plan) * (plan.quantity ?? 1)) | currencyBRL }}<span *ngIf="showsMonthlySuffix(plan)" class="plan-price-period">{{ 'components.cartProductItem.perMonth' | i18n }}</span>
                </span>
                <span *ngIf="isOneTimePlan(plan)" class="plan-price-note">{{ 'components.cartProductItem.oneTimePayment' | i18n }}</span>
                <span
                  class="plan-price-from"
                  *ngIf="isMind && plan.hasPromotion && plan.originalUnitPrice"
                >{{ 'components.productCard.fromPriceMonthly' | i18n: { price: formatPlanOriginalPrice(plan) } }}</span>
              </div>
            </div>

            <ng-container *ngFor="let suggestion of plan.suggestions ?? []; trackBy: trackSuggestionIndex">
              <div class="domain-promo-nested">
                <div class="domain-promo-nested__connector" aria-hidden="true"></div>
                <umkt-cart-product-suggestion
                  class="domain-promo-nested__promo"
                  [suggestion]="suggestion"
                  [loading]="suggestionLoadingId === suggestion.id"
                  (accept)="suggestionAccept.emit($event)"
                  (dismiss)="suggestionDismiss.emit($event)"
                ></umkt-cart-product-suggestion>
              </div>
            </ng-container>

            <ng-container *ngFor="let promo of plan.domainPromos ?? []; trackBy: trackDomainPromoIndex">
              <div class="domain-promo-nested">
                <div class="domain-promo-nested__connector" aria-hidden="true"></div>
                <umkt-domain-promo
                  class="domain-promo-nested__promo"
                  [domainName]="promo.domainName"
                  [isFree]="promo.isFree"
                  [price]="promo.price"
                  [priceText]="promo.priceText ?? ''"
                  [icon]="promo.icon ?? fallbackDomainPromoIcon"
                ></umkt-domain-promo>
              </div>
            </ng-container>
          </li>
        </ng-container>
      </ul>
    </div>
  </ng-container>
  <div class="product-separate" *ngIf="!useCategoryLayoutWhenEmpty && (!isCartEmpty || !lastChild)"></div>
</div>
<umkt-loading [isLoading]="loadingShow" mode="contained"></umkt-loading>